export default __webpack_public_path__ + "static/media/mobileWef7.a732cc85.png";